<template>
    <a-modal
        :class="'modal'"
        :title="modal_title ? modal_title : $t('globals.navigation.user.email_modal.title')"
        :destroyOnClose="true"
        :afterClose="onClose"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <div class="form-section">
            <div class="section-body" data-cy="user-email-subject-field">
                <a-auto-complete
                    v-model:value="v$.email_data.subject.$model"
                    @search="handleSearch"
                    @select="selectSubject"
                    :options="email_descriptions"
                    :placeholder="$t('globals.navigation.user.forms.email.subject')"
                    :class="{ 'form-error': v$.email_data.subject.$error }"
                    class="w-full"
                />
                <div
                    data-cy="field-email-subject-error"
                    :class="{
                        'text-default-red': v$.email_data.subject.$error && v$.email_data.subject.required.$invalid,
                    }"
                    v-if="v$.email_data.subject.$error && v$.email_data.subject.required.$invalid"
                >
                    {{ $t('validation.required') }}
                </div>
            </div>
            <div class="mt-2" data-cy="user-email-body-field">
                <ui-text-area
                    :placeholder="$t('globals.navigation.user.forms.email.body')"
                    :class="{ 'form-error': v$.email_data.body.$error }"
                    v-model="v$.email_data.body.$model"
                />
                <div
                    data-cy="field-email-body-error"
                    :class="{ 'text-default-red': v$.email_data.body.$error }"
                    v-if="v$.email_data.body.required.$invalid && v$.email_data.body.$error"
                >
                    {{ $t('validation.required') }}
                </div>
            </div>
        </div>
        <template #footer>
            <ui-checkbox
                v-if="modal_type == 'user'"
                data-cy="user-email-is-bcc-sender-field"
                class="absolute left-0 ml-4"
                v-model="email_data.is_bcc_sender"
            >
                {{ $t('globals.navigation.user.forms.email.bcc_sender') }}
            </ui-checkbox>
            <ui-checkbox
                v-if="modal_type == 'admin'"
                data-cy="user-email-is-copy-request-field"
                class="absolute left-0 ml-4"
                v-model="email_data.copy_request"
            >
                {{ $t('globals.navigation.user.forms.email.copy_request') }}
            </ui-checkbox>
            <a-button data-cy="user-email-send" key="submit" type="primary" :loading="processing" @click="handleSubmit">
                {{ $t('globals.navigation.user.email_modal.send') }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';
import UiSelect from '@/components/ui/Select.vue';
import UiInput from '@/components/ui/Input.vue';
import UiTextArea from '@/components/ui/TextArea.vue';
import UiCheckbox from '@/components/ui/Checkbox.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: { UiLabel, UiSelect, UiInput, UiTextArea, UiCheckbox },
    data() {
        return {
            modal_visible: false,
            email_descriptions: [],
            email_list: [],
            processing: false,
        };
    },
    validations: {
        email_data: {
            subject: { required },
            body: { required },
        },
    },
    props: {
        email_data: {
            type: Object,
            default: {
                subject: '',
                body: '',
            },
        },
        modal_title: {
            type: String,
            default: null,
        },
        modal_type: {
            type: String,
            default: 'user',
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
            this.selectSubject('');
        },
        onClose() {
            this.v$.$reset();
        },
        handleSearch(value) {
            value = value.toLowerCase();
            this.$http
                .get('/api/listmanager/category/email_template')
                .then((response) => {
                    const filtered_email_descriptions = response.data.data.filter((record) =>
                        record.value.toLowerCase().includes(value),
                    );

                    this.email_descriptions = filtered_email_descriptions.map((record) => ({
                        value: record.value,
                        label: record.description,
                    }));
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVSH04' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.modal_visible = false;

            this.$emit('formSubmit', {
                key: 'email_user',
                data: this.email_data,
            });
        },
        selectSubject(value) {
            this.handleSearch(value);
            this.email_descriptions.forEach((email_description) => {
                if (email_description.value == value) {
                    this.v$.email_data.body.$model = email_description.label;
                }
            });
        },
    },
};
</script>
